import ClosedQuestion from 'models/common/form/question/ClosedQuestion';

export default class DropdownClosedQuestion extends ClosedQuestion {}
